module.exports = __webpack_public_path__ + "img/manzana.bc03e3d3.svg";